import { useCallback } from 'react';
import * as R from '@/Router/routes';
import { withdrawDaysDiff, isWithdrawFlowDone } from '@/utils/withdrawFlow'; // adjust path if needed
import type { WithdrawDataDatetype } from '@/hooks/webapi/client/useWithdrawQuery'; // adjust path if needed
import { WITHDRAW_MIN_BROKEN_DAYS } from '@/utils/constants';
import { LatestLoan } from './providers/useLatestLoanProvider';

const useDashboardRoute = () => {
  const getDashboardRoute = useCallback(
    (
      latestLoan: LatestLoan | null | undefined,
      withdrawData: WithdrawDataDatetype | null | undefined,
    ) => {
      if (!latestLoan) return R.REPEATED_LOAN;

      const withdrawDashboard =
        withdrawDaysDiff(withdrawData) >= WITHDRAW_MIN_BROKEN_DAYS
          ? R.WITHDRAW_DASHBOARD_BROKEN
          : R.WITHDRAW_DASHBOARD;

      const isDebtSchedule = latestLoan?.hasActiveDebtSchedule;
      const isOverdue = latestLoan?.overDueDays > 0;
      const isBroken = latestLoan?.debtCollectLoanAgreement && isOverdue;
      const isWithdrawDone = isWithdrawFlowDone(latestLoan);

      if (isWithdrawDone) return withdrawDashboard;
      if (isDebtSchedule) return R.OVERDUE_DEBT_SCHEDULE;
      if (isBroken) {
        return isWithdrawDone
          ? R.WITHDRAW_DASHBOARD_BROKEN
          : R.BROKEN_AGREEMENT;
      }
      if (isOverdue) return R.OVERDUE_LOAN;
      return isWithdrawDone ? withdrawDashboard : R.ACTIVE_LOAN;
    },
    [],
  );

  return { getDashboardRoute };
};

export default useDashboardRoute;
